module.exports = __webpack_public_path__ + "img/building.3b5eb7bb.svg";